import React, { useEffect, useState } from "react";
import Lottie from "react-lottie-player";
import loadinganimation from "../../assets/loadinganimation.json";
import successanimation from "../../assets/successanimation.json";
import failureanimation from "../../assets/failureanimation.json";
import "./styles.css";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const PaymentProcessingScreen = () => {
  const { orderId } = useParams();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);
  const [transactionObj, setTransactionObj] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [lang, setLanguage] = useState("en");
  const [responseData, setResponseData] = useState(null);
  const navigate = useNavigate();

  const fetchTransactionDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/payment/payment-complete/${orderId}`
      );
      console.log("response:", response);
      setResponseData(response);

      const data = response.data;
      setLanguage(data.lang);
      console.log("data:", data);
      localStorage.setItem("userLang", data.lang);

      if (response.status === 200) {
        if (data.allocationStatus === "success") {
          setTransactionObj(data.transactionObj);
          setTransactionDetails(data.transactionDetails);
          setStatus("success");
        } else {
          setError(lang === "th"
            ? "เกิดข้อผิดพลาดขณะดึงข้อมูลการทำธุรกรรม."
            : "An error occurred while fetching transaction details.");
          setStatus("failure");
        }
      } else {
        setError(lang === "th"
          ? "สถานะการตอบกลับไม่ถูกต้อง."
          : "Unexpected response status.");
        setStatus("failure");
      }
    } catch (e) {
      localStorage.setItem("userLang", e.response.data.lang);
      setLanguage(e.response.data.lang);
      if (e.response && e.response.status === 404) {
        navigate(`/order-not-found`);
      } else if (e.response && e.response.status === 409) {
        setError(lang === "th"
          ? "คำสั่งซื้อนี้เสร็จสมบูรณ์แล้ว. กรุณาตรวจสอบรายละเอียดคำสั่งซื้อ."
          : "Order already completed. Please check your order details.");
        setStatus("failure");
      } else if (e.response && e.response.status === 402) {
        setError(lang === "th"
          ? "การชำระเงินล้มเหลว กรุณาตรวจสอบข้อมูลการชำระเงินของคุณและลองอีกครั้ง."
          : "Payment failed. Please check your payment information and try again.");
        setStatus("failure");
      }
      else {
        console.error("Error fetching transaction details:", e);
        setError(lang === "th"
          ? e.message || "เกิดข้อผิดพลาดในการดึงข้อมูลการทำธุรกรรม."
          : e.message || "Failed to fetch transaction details.");
        setStatus("failure");
      }
    }
  };

  useEffect(() => {
    fetchTransactionDetails();
  }, [orderId]);

  const renderContent = () => {
    const loadingText = lang === "th"
      ? "กำลังโหลดข้อมูลคำสั่งซื้อ กรุณาอย่าปิดเบราว์เซอร์"
      : "Order details loading, Please do not close the browser";

    const loadedText = lang === "th"
      ? "คำสั่งซื้อกำลังถูกประมวลผล กรุณาอย่าปิดเบราว์เซอร์"
      : "The order is being processed. Please do not close your browser.";

    const successText = lang === "th"
      ? "คำสั่งซื้อสำเร็จ กรุณาปิดเบราว์เซอร์"
      : "Order was successfully processed. Please close the browser.";

    const failureText = error || (lang === "th"
      ? "คำสั่งซื้อไม่สำเร็จ"
      : "Order failed");

    const renderDetails = () => (
      <>
        <p id="amount">
          {lang === "th" ? "จำนวนเงิน" : "Amount"}: ฿{transactionObj.amount}
        </p>
        <p id="date">
          {lang === "th" ? "วันที่" : "Date"}:{" "}
          {new Date(transactionObj.paidAt || transactionObj.created_at).toLocaleDateString()}
        </p>
        <p id="transaction-id">
          {lang === "th" ? "หมายเลขธุรกรรม" : "Transaction ID"}: {transactionObj.transactionId}
        </p>
      </>
    );

    switch (status) {
      case "loading":
        return (
          <div className="success-container">
            <div><p>{loadingText}</p></div>
            <Lottie loop animationData={loadinganimation} play style={{ width: 150, height: 150, alignSelf: "center" }} />
            <div>
              <p className="loading">{loadingText}</p>
              {/* <p className="loaded">{loadedText}</p> */}
            </div>
          </div>
        );
      case "success":
        return (
          <div className="success-container-post-transaction">
            <Lottie loop animationData={successanimation} play style={{ width: 150, height: 150 }} />
            <p>{successText}</p>
            {transactionObj && renderDetails()}
          </div>
        );
      case "failure":
        return (
          <div className="success-container-post-transaction">
            <Lottie loop animationData={failureanimation} play style={{ width: 150, height: 150 }} />
            <p>{failureText}</p>
            {transactionObj && renderDetails()}
          </div>
        );
      default:
        return null;
    }
  };

  return <div className="main">{renderContent()}</div>;
};

export default PaymentProcessingScreen;
